export default "__VITE_ASSET__f1a0c23d__"